// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010419/js/" + chunkId + "." + {"44":"7ecf0d17","225":"b539e119","481":"3be4fe56","486":"09bb004a","770":"f436bfaf"}[chunkId] + ".0.11691495147965492.chunk.js";
};